/**
 * ============================================================================
 * GENERATED FILE - Created via: pnpm run generate:wetags
 * ============================================================================
 *
 * This file was generated by the wetag library generator.
 *
 * To add new entity types or update configuration, run:
 *   pnpm run generate:wetags
 *
 * You can safely modify this file if needed, but using the generator
 * ensures consistency across all wetag libraries in the codebase.
 *
 * To add type-safe tag names, update the tags.ts file in this directory.
 * ============================================================================
 */

import { useLocationGroupStore } from '@frontend/scope';
import { createNamespacedWetagHooks, createNamespacedWetagHooksForOrg } from '@frontend/wetags';
import type { CallIntelligenceTags } from './tags';

const useGetCurrentLocationId = () => {
  const locationId = useLocationGroupStore((state) => state.selectedLocationIds[0] || '');
  return locationId;
};

const CALL_INTELLIGENCE_NAMESPACE = 'call-intelligence';

export const CallIntelligenceWetags = createNamespacedWetagHooks<CallIntelligenceTags>(
  CALL_INTELLIGENCE_NAMESPACE,
  useGetCurrentLocationId
);

export const CallIntelligenceOrgWetags =
  createNamespacedWetagHooksForOrg<CallIntelligenceTags>(CALL_INTELLIGENCE_NAMESPACE);
